<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
          <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
          <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
          <v-toolbar-title v-if="tranMode === 'New'">New Statement Line Type by Statement Type</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Review'">Edit Statement Line Type by Statement Type</v-toolbar-title>
          <v-toolbar-title v-if="tranMode === 'Query'">Query Statement Line Type by Statement Type</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex lg12 md12 xs12 v-if="newMode">
                <v-autocomplete
                  :items="acctTypeList"
                  :label="labels.riType"
                  v-model="form.riType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="riType"
                  :data-vv-as="labels.riType"
                  :error-messages="errors.collect('riType')"
                  v-validate="'entry'"
                ></v-autocomplete>
              </v-flex>
              <v-flex lg6 md6 xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.riType }}</v-subheader>
                <div class="queryValue">{{ form.riType }}</div>
              </v-flex>
              <v-flex lg12 md12 xs12 v-if="newMode">
                <v-text-field
                  v-model="form.stmtType"
                  :label="labels.stmtType"
                  :error-messages="errors.collect('form.stmtType')"
                  data-vv-name="form.stmtType"
                  :data-vv-as="labels.stmtType"
                  v-validate="'required'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('stmtType')"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.stmtType }}</v-subheader>
                <div class="queryValue">{{ form.stmtType }}</div>
              </v-flex>
              <v-flex lg12 md12 xs12 v-if="newMode">
                <v-text-field
                  v-model="form.stmtLnSeq"
                  :label="labels.stmtLnSeq"
                  :error-messages="errors.collect('form.stmtLnSeq')"
                  data-vv-name="form.stmtLnSeq"
                  :data-vv-as="labels.stmtLnSeq"
                  v-validate="'required'"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.stmtLnSeq }}</v-subheader>
                <div class="queryValue">{{ form.stmtLnSeq }}</div>
              </v-flex>
              <v-flex lg12 md12 xs12 v-if="!queryMode">
                <v-text-field
                  v-model="form.stmtLnType"
                  :label="labels.stmtLnType"
                  :error-messages="errors.collect('form.stmtLnType')"
                  data-vv-name="form.stmtLnType"
                  :data-vv-as="labels.stmtLnType"
                  v-validate="'required'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('stmtLnType')"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.stmtLnType }}</v-subheader>
                <div class="queryValue">{{ form.stmtLnType }}</div>
              </v-flex>
              <v-flex lg12 md12 xs12>
                <v-checkbox
                  v-model="form.prtStmt"
                  :label="labels.prtStmt"
                  data-vv-name="prtStmt"
                  :data-vv-as="labels.prtStmt"
                  :error-messages="errors.collect('prtStmt')"
                  :disabled="queryMode"
                  hide-details
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ form.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ form.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ form.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
        <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
          Save
          <v-icon right>mdi-content-save </v-icon>
        </v-btn>
      </v-card>
      <v-dialog v-model="filterHelplist" width="900px" persistent>
        <stmtType-help-list v-if="stmtTypeHelplist" @close="doClose" @selectStmtType="doAssign($event)"></stmtType-help-list>
        <stmtLnType-help-list
          v-if="stmtLnTypeHelplist"
          :prtFrom="this.isPrtForm"
          @close="doClose"
          @selectStmtLnType="doAssign($event)"
        ></stmtLnType-help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { acctType } from '@/const/params'
import { expandURI } from '@/utils/ajax'
import StmtTypeHelplist from './helplist/StmtTypeHelplist'
import StmtLnTypeHelplist from './helplist/StmtLnTypeHelplist'

export default {
  data() {
    return {
      newMode: true,
      reviewMode: false,
      queryMode: false,
      submitting: false,
      filterHelplist: false,
      stmtTypeHelplist: false,
      stmtLnTypeHelplist: false,
      isPrtForm: false,
      prtForm: undefined,
      labels: {
        riType: 'Inwards / Outwards',
        stmtType: 'Statement Type',
        stmtLnSeq: 'Statement Line Sequence No.',
        stmtLnType: 'Statement Line Type',
        prtStmt: 'Print on Statement',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      filters: {},
      form: {
        riType: 'O',
        stmtType: null,
        stmtLnSeq: 0,
        stmtLnType: undefined,
        prtStmt: true,
        createdBy: null,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      }
    }
  },
  watch: {
    prtFormat: function (value) {
      if (value === 'C011' || value === 'R011') {
        this.isPrtForm = true
      }
    },
    'form.stmtLnSeq': function (value) {
      if (value > 0) {
        this.resetMessages()
      }
    }
  },
  methods: {
    async doFetchData() {
      const apiURI = this.menu.getStmtTypeStmtLnType
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            riType: this.stmtTypeStmtLnType.riType,
            stmtType: this.stmtTypeStmtLnType.stmtType,
            stmtLnSeq: this.stmtTypeStmtLnType.stmtLnSeq
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.riType = data.stmtTypeStmtLnType.riType
            this.form.stmtType = data.stmtTypeStmtLnType.stmtType
            this.form.stmtLnSeq = data.stmtTypeStmtLnType.stmtLnSeq
            this.form.stmtLnType = data.stmtTypeStmtLnType.stmtLnType
            this.form.prtStmt = data.stmtTypeStmtLnType.prtStmt
            this.form.createdBy = data.stmtTypeStmtLnType.createdBy
            this.form.createdDate = data.stmtTypeStmtLnType.createdDate
            this.form.modifiedBy = data.stmtTypeStmtLnType.modifiedBy
            this.form.modifiedDate = data.stmtTypeStmtLnType.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    },
    doCancel() {
      this.$router.push({ name: 'stmtTypeStmtLnType' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createStmtTypeStmtLnType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'stmtTypeStmtLnType' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateStmtTypeStmtLnType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'stmtTypeStmtLnType' })
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldname) {
      this.filterHelplist = true
      if (fieldname === 'stmtType') {
        this.stmtTypeHelplist = true
      } else if (fieldname === 'stmtLnType') {
        this.stmtLnTypeHelplist = true
      }
    },
    doAssign(stmtTypeObj) {
      if (stmtTypeObj.stmtTypeOpt === 'stmtType') {
        this.stmtTypeHelplist = false
        this.form.stmtType = stmtTypeObj.stmtType
        this.prtForm = stmtTypeObj.prtForm
      } else if (stmtTypeObj.stmtTypeOpt === 'stmtLnType') {
        this.stmtLnTypeHelplist = false
        this.form.stmtLnType = stmtTypeObj.stmtLnType
      }
      this.filterHelplist = false
    },
    doClose() {
      this.filterHelplist = false
      this.stmtTypeHelplist = false
      this.stmtLnTypeHelplist = false
    }
  },
  computed: {
    stmtTypeStmtLnType() {
      return this.$route.params.stmtTypeStmtLnType
    },
    tranMode() {
      return this.$route.params.tranMode
    },
    menu() {
      return this.$store.state.stmtType.menu
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  created() {
    if (this.stmtTypeStmtLnType === undefined && this.tranMode === undefined) {
      this.$router.push({ name: 'stmtTypeStmtLnType' })
    }
    if (this.stmtTypeStmtLnType === 'new') {
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
    } else if (this.tranMode === 'Review') {
      this.newMode = false
      this.reviewMode = true
      this.queryMode = false
      this.doFetchData()
    } else if (this.tranMode === 'Query') {
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
      this.doFetchData()
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    'stmtType-help-list': StmtTypeHelplist,
    'stmtLnType-help-list': StmtLnTypeHelplist
  }
}
</script>
